// A7 (30 Oct) — the Report and shared pages' summary: the plant's own parts, the §01 grid phrases.
const GRID = { off_grid: "off-grid", on_grid: "on-grid", weak_grid: "on a weak-grid connection" };

const article = (word) => (/^[aeiou]/i.test(word) ? "an" : "a");

export const memoCountry = (c) => (c === "DRC" ? "the DRC" : c === "Cote d'Ivoire" ? "Côte d'Ivoire" : c);

export const memoGrid = (g) => GRID[g] || String(g || "").replace(/_/g, " ");

export const memoSector = (s) => {
  const w = String(s || "").toLowerCase();
  return { a: article(w), sector: w };
};

export function memoParts(m) {
  const on = (k) => Number(m?.[k] || 0) > 0;
  const parts = [];
  if (on("solar_kw")) parts.push("solar PV");
  if (on("wind_kw")) parts.push("wind");
  if (on("battery_kwh")) parts.push("battery storage");
  if (on("gas_kw")) parts.push("gas engines");
  if (on("ocgt_kw")) parts.push("OCGT");
  if (on("ccgt_kw")) parts.push("CCGT");
  if (on("hfo_kw")) parts.push("HFO engines");
  if (on("genset_kw")) parts.push(m?.genset_role === "blackstart" ? "a diesel black-start set" : "diesel gensets");
  if (parts.length < 2) return parts.join("");
  return `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;
}

// French counterparts for the Report and shared pages.
const GRID_FR = { off_grid: "hors réseau", on_grid: "raccordé au réseau", weak_grid: "sur un raccordement au réseau faible" };
export const memoGridFr = (g) => GRID_FR[g] || String(g || "").replace(/_/g, " ");

export function memoPartsFr(m) {
  const on = (k) => Number(m?.[k] || 0) > 0;
  const parts = [];
  if (on("solar_kw")) parts.push("du solaire PV");
  if (on("wind_kw")) parts.push("de l'éolien");
  if (on("battery_kwh")) parts.push("du stockage par batterie");
  if (on("gas_kw")) parts.push("des moteurs à gaz");
  if (on("ocgt_kw")) parts.push("une OCGT");
  if (on("ccgt_kw")) parts.push("une CCGT");
  if (on("hfo_kw")) parts.push("des moteurs HFO");
  if (on("genset_kw")) parts.push(m?.genset_role === "blackstart" ? "un groupe diesel de démarrage autonome" : "des groupes diesel");
  if (parts.length < 2) return parts.join("");
  return `${parts.slice(0, -1).join(", ")} et ${parts[parts.length - 1]}`;
}
